import React from 'react';
import Grid from '../layout/grid';
import Select from 'react-select';

export default props => (
    <Grid cols={props.cols}>
        <div className='form-group'>
			{props.label &&
			<label htmlFor={props.name}>{props.label}</label>}
			{props.multiple ? (
				<Select
					readOnly={props.readOnly}
					isMulti
					defaultValue={props.value}
					placeholder={props.placeholder}
					isClearable={true}
					isSearchable={true}
					onChange={(item) => props.onChange(item)}
					options={(props.options || []).map(opt => ({ value: opt.id, label: opt.valor }))} />
			) : (props.onChange ? (
				<Select
					readOnly={props.readOnly}
					value={props.value !== null && props.value !== undefined
						? (props.options || []).map(opt => ({ value: opt.id, label: opt.valor })).find(opt => String(opt.value) === String(props.value)) || null
						: null}
					placeholder={props.placeholder}
					isClearable={true}
					isSearchable={true}
					isDisabled={props.readOnly ? true : false}
					onChange={(item) => props.onChange(item ? item.value : null)}
					options={(props.options || []).map(opt => ({ value: opt.id, label: opt.valor }))} />
			) : (
				<Select
					readOnly={props.readOnly}
					placeholder={props.placeholder}
					isClearable={true}
					isSearchable={true}
					isDisabled={props.readOnly ? true : false}
					defaultValue={props.input.value ? (props.options || []).map(opt => ({ value: String(opt.id), label: opt.valor })).filter(opt => opt.value == props.input.value)[0] || null : null}
					onChange={(item) => props.input.onChange(item ? item.value : null)}
					onBlur={(value) => props.input.onBlur()}
					options={(props.options || []).map(opt => ({ value: opt.id, label: opt.valor }))} />
			))}
       </div>
   </Grid>
)
